// extracted by mini-css-extract-plugin
export default {"input":"noa-z","button":"ooa-z","selected":"poa-z","unavailable":"qoa-z","image":"roa-z"};